import React from "react";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";
import { AppContext } from "../../../contexts/AppContext";
import { formataData } from "../../../helpers/mesesHelper";
import Format from "../../../helpers/Format";

function MigracaoDataTable({
  linhas,
  togNovoProcessoModal,
  togUsuariosModal,
  deletarProcesso,
  togNovoUsuarioModal,
  togAdministradoresMigracaoModal,
  togFastMigracaoModal,
}) {
  const { baseUrl } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome da empresa",
        accessor: (row) => {
          return <h5 className="font-size-14">{row.razao_social}</h5>;
        },
      },
      {
        Header: "Criação",
        accessor: (row) => {
          return formataData(row.created_at.split("T")[0] ?? "");
        },
        disableSortBy: true,
      },
      {
        Header: "Mensalidade",
        accessor: (row) => {
          if (!row.dados_empresa) return Format.formataValor(0);
          const mensalidade = parseFloat(row.dados_empresa.mensalidade) || 0;
          return Format.formataValor(
            Number.isNaN(mensalidade) ? 0 : mensalidade
          );
        },
        disableSortBy: true,
      },
      {
        Header: "E-mail",
        accessor: (row) => {
          return row.dados_empresa && row.dados_empresa.email_empresa;
        },
      },
      {
        Header: "Progresso",
        accessor: (row) => {
          return `${row.etapa_concluida}/5`;
        },
        disableSortBy: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          status.push(
            <>
              <DropdownButton
                key={`criar-usuario-${row.original.uid}`}
                onClick={() => {
                  togNovoUsuarioModal(row.original.uid);
                }}
                color="success"
                icon="fas fa-user-plus"
              >
                Criar usuário
              </DropdownButton>
              <DropdownButton
                key={`visualizar-usuario-${row.original.uid}`}
                onClick={() => {
                  togUsuariosModal(row.original.uid);
                }}
                color="primary"
                icon="fas fa-user-friends"
              >
                Visualizar usuários
              </DropdownButton>
              <DropdownButton
                key={`visualizar-administradores-${row.original.uid}`}
                onClick={() => {
                  togAdministradoresMigracaoModal(row.original.uid);
                }}
                color="orange"
                icon="fas fa-user-friends"
              >
                Administradores
              </DropdownButton>
              <DropdownButton
                key={`consultar-${row.original.uid}`}
                onClick={() => {
                  window.location.href =
                    baseUrl +
                    `timeline/TimelineMigracao/index/${row.original.uid}`;
                }}
                color="warning"
                icon="fas fa-folder-open"
              >
                Consultar processo
              </DropdownButton>
              <DropdownButton
                key={`deletar-${row.original.uid}`}
                onClick={() => {
                  deletarProcesso(row.original.uid);
                }}
                color="danger"
                icon="fas fa-trash-alt"
              >
                Deletar processo
              </DropdownButton>
            </>
          );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      baseUrl,
      deletarProcesso,
      togAdministradoresMigracaoModal,
      togNovoUsuarioModal,
      togUsuariosModal,
    ]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <>
          <ButtonRounded
            onClick={togNovoProcessoModal}
            color="success"
            icon={<FaPlus />}
          >
            Novo processo
          </ButtonRounded>
          <ButtonRounded
            onClick={togFastMigracaoModal}
            color="success"
            icon={<FaPlus />}
          >
            Fast processo
          </ButtonRounded>
        </>
      }
    />
  );
}

MigracaoDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togNovoProcessoModal: PropTypes.func.isRequired,
  togUsuariosModal: PropTypes.func.isRequired,
  deletarProcesso: PropTypes.func.isRequired,
  togNovoUsuarioModal: PropTypes.func.isRequired,
  togAdministradoresMigracaoModal: PropTypes.func.isRequired,
  togFastMigracaoModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default MigracaoDataTable;
